import React, { createContext, useContext, useEffect, useState } from 'react';
import api from './services/api';

// Contexte global : le référentiel (branches, métiers, sociétés, catalogue de
// rapports) est chargé UNE fois et partagé par la sidebar, l'accueil et les
// pages Rapport — c'est ce qui rend la navigation instantanée (1 clic).
const BiContext = createContext(null);

// `user` : le profil connecté. `ia` = son droit « Analyse IA » (aucune /
// lecture / generation), qui masque le bouton quand il vaut « aucune ».
export function BiProvider({ children, user }) {
  const [data, setData] = useState({ branches: [], metiers: [], societes: [], rapports: [] });
  const [chargement, setChargement] = useState(true);
  const [branche, setBranche] = useState(null);

  useEffect(() => {
    api.get('/bi/home')
      .then((res) => {
        setData(res.data);
        setBranche((b) => b || res.data.branches[0]?.code || null);
      })
      .catch(() => {})
      .finally(() => setChargement(false));
  }, []);

  return (
    <BiContext.Provider value={{ data, chargement, branche, setBranche, ia: user?.ia || 'lecture', exportExcel: !!user?.export_excel }}>
      {children}
    </BiContext.Provider>
  );
}

export const useBi = () => useContext(BiContext);
